import React from 'react';
import ModuleEditablePopup from '../moduleEditablePopup/ModuleEditablePopup';

const ModuleSearchBar = (props) => {
  const moduleInit = {
    areaNm: '',
    calibration: null,
    modelNm: '',
    modelNo: '',
    moduleGroup: null,
    moduleScn: '0',
    moduleType: 'IT',
  };

  return (
    <div className="searchBar-conatiner">
      <div className="form-row">
        <div className="search-condition col-xl-2 col-sm-6">
          <label>운용유형</label>
          <select className="table-search-input up-check" onChange={({ target: { value } }) => props.setModuleType(value)}>
            <option value="">전체</option>
            <option value="DT">이동형</option>
            <option value="IT">휴대형</option>
          </select>
        </div>
        <ModuleEditablePopup module={moduleInit} dataReloadFunc={props.setTableData}>
          <div className="search-condition col-xl-1 col-sm-6">
            <button className="table-search-submit btn btn-info">등록</button>
          </div>
        </ModuleEditablePopup>
      </div>
    </div>
  );
};

export default ModuleSearchBar;
